// reducers/CustomeSaleReport.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    sales: [],
    summary: {
      totalCount: 0,
      totalAmount: 0
    }
  },
  loading: false,
  error: null,
};

const customeSaleReportSlice = createSlice({
  name: "customeSaleReport",
  initialState,
  reducers: {
    salesReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    salesReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload.data;
    },
    salesReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSalesReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    }
  },
});

export const {
  salesReportRequest,
  salesReportSuccess,
  salesReportFailure,
  resetSalesReport,
} = customeSaleReportSlice.actions;

export default customeSaleReportSlice.reducer;